import { Outlet } from 'react-router';
import { AppLayout } from '@/layouts/app/app-layout';
import { useAuthorizedLayoutItems } from '@/layouts/app/use-authorized-layout-items';

export function AuthLayout(): React.ReactElement {
  const { headerItems, footerItems } = useAuthorizedLayoutItems();

  return (
    <AppLayout headerItems={headerItems} footerItems={footerItems}>
      <Outlet />
    </AppLayout>
  );
}
